import React from "react";
import ChartEditButton from "./ChartEditButton";
import ChartSaveButton from "./ChartSaveButton";
import ChartZoomMenu, { ChartZoomMenuParam } from "./ChartZoomMenu";
import ChartEditMenu, { ChartEditMenuParam } from "./ChartEditMenu";

export interface ChartDialogMenuParam
  extends ChartZoomMenuParam,
    ChartEditMenuParam {
  /**
   * 編集状態の場合true,それ以外の場合falseを設定します
   */
  edit: boolean;
  /**
   * ChartEditMenuを有効にする場合はtrue,それ以外はfalseを設定します
   */
  editMenu: boolean;
  /**
   * 編集ボタンがクリックされた場合に呼び出されます
   */
  onEdit?: () => void;
  /**
   * 保存ボタンがクリックされた場合に呼び出されます
   */
  onSave?: () => void;
}

/**
 * チャートダイアログメニューを表示します
 * @param {ChartDialogMenuParam} props - ダイアログメニューパラメータ
 * @returns チャートダイアログメニュー
 */
export default function ChartDialogMenu(props: ChartDialogMenuParam) {
  const {
    edit,
    editMenu,
    onEdit,
    onSave,
    onXZoomUp,
    onXZoomOut,
    onYZoomUp,
    onYZoomOut,
    id,
    x,
    range,
    onRegist,
  } = props;
  const buttonEdit = !edit ? (
    <ChartEditButton onClick={onEdit} />
  ) : (
    <ChartSaveButton onClick={onSave} />
  );
  const chartEditMenu =
    edit && editMenu ? (
      <ChartEditMenu id={id} x={x} range={range} onRegist={onRegist} />
    ) : (
      ""
    );
  return (
    <div>
      <div>{buttonEdit}</div>
      <ChartZoomMenu
        onXZoomUp={onXZoomUp}
        onXZoomOut={onXZoomOut}
        onYZoomUp={onYZoomUp}
        onYZoomOut={onYZoomOut}
      />
      <div style={{ height: "25px" }}></div>
      {chartEditMenu}
    </div>
  );
}
